import React, { useState } from "react";
import CreateBracketOpener from "components/reusable/CreateBracketOpener";
import ViewBracketOpener from "components/reusable/ViewBracketOpener";
import "./LandingPage.css";
import { getRecentCreateBrackets } from "../../utilities/js/localstorage/StorageHelper_CreateBrackets";
import { getRecentViewBrackets } from "../../utilities/js/localstorage/StorageHelper_ViewBrackets";
import LoginForm from "../../components/account-screen/LoginForm";
import AccountSettingsTabs from "../../components/account-screen/AccountSettingsTabs";
import FullPagePanel from "../../components/reusable/FullPagePanel";
import Panel from "../../components/reusable/Panel";
import Toast from '../../components/reusable/Toast';
import HomePage from "../home/HomePage";
import BracksetHeader from "components/reusable/BracksetHeader";
import BracksetFooter from "components/reusable/BracksetFooter";
import { freezeBody, unfreezeBody } from "utilities/js/styling/domUtilities";
import { navigateToNew } from "utilities/js/NavigationHelper";
import { isLoggedIn } from "utilities/js/ActionLibrary";

import { useNavigate } from "react-router-dom";
import VerifyEmailPrompt from "components/reusable/VerifyEmailPrompt";
import Constants from "utilities/js/Constants";
import InstallInstructions from "InstallInstructions";

const LogoIcon = Constants.ICON_LOGO_THEME;
const checkIcon = Constants.ICON_CHECK;

const LandingPage = props => {
    const [displayViewPanel, setDisplayViewPanel] = useState(false);
    const [displayCreatePanel, setDisplayCreatePanel] = useState(false);
    const [displayAccountPanel, setDisplayAccountPanel] = useState(false);
    const [bracketsToUpdate, setBracketsToUpdate] = useState(getRecentCreateBrackets());
    const [bracketsToView, setBracketsToView] = useState(getRecentViewBrackets());
    const [toastMessages, setToastMessages] = useState([]);


    const navigate = useNavigate();

    function openNewBracket() {
        navigateToNew({ routerNav: navigate })
    }
    function openViewPanel() {
        //open modal with recent brackets you've viewed
        setDisplayViewPanel(true);
        freezeBody();
    }

    function openCreatePanel() {
        //open modal with most recent brackets you've created
        setDisplayCreatePanel(true);
        freezeBody();
    }

    function closeViewPanel() {
        //open modal with recent modals you've viewed
        setDisplayViewPanel(false);
        unfreezeBody();
    }

    function closeCreatePanel() {
        //open modal with recent brackets you've viewed
        setDisplayCreatePanel(false);
        unfreezeBody();
    }

    function openAccountPanel() {
        //open modal with recent modals you've viewed
        setDisplayAccountPanel(true);
        freezeBody();
    }

    function closeAccountPanel() {
        //close modal with recent modals you've viewed
        setDisplayAccountPanel(false);
        unfreezeBody();
    }


    function showInfoToast(message) {
        let toastMessages = [...toastMessages];
        toastMessages.push({
            id: Math.floor((Math.random() * 101) + 1),
            title: 'Success',
            description: message,
            backgroundColor: '#4a4d4e',
            icon: checkIcon
        });
        setToastMessages(toastMessages);
    }

    function displayAccountPanelUI() {
        if (isLoggedIn()) {
            return (<AccountSettingsTabs></AccountSettingsTabs>)
        } else {
            return (<LoginForm closePanel={closeAccountPanel} showToast={showInfoToast}></LoginForm>);
        }
    }



    if (isLoggedIn()) {
        return (<HomePage></HomePage>)
    }

    return (
        <>
            {/* <AccountControl></AccountControl> */}
            <div className="landing-page-layout">
                <VerifyEmailPrompt></VerifyEmailPrompt>
                <BracksetHeader hideSearch="true"></BracksetHeader>
                <div className="landing-nav-container">
                    <div className="logo-container"><img className="bracket-logo" alt="bracket-logo" src={LogoIcon} /> </div>
                    <div className="landing-page-masthead">Brackset</div>
                    <div className="landing-page-tagline">The worldwide leader in bracket generation</div>
                    <div className="landing-nav-buttons">
                        <div className="nav-button-container view"><button className="nav-button" onClick={openViewPanel}>View</button></div>
                        <div className="nav-button-container update"><button className="nav-button" onClick={openNewBracket}>Create</button></div>
                    </div>
                </div>
                <BracksetFooter variant="true"></BracksetFooter>
            </div>

            <Panel shouldDisplay={displayViewPanel} headerText="View Brackets" closePanel={closeViewPanel} showClose="true">
                <ViewBracketOpener bracketsToView={bracketsToView}></ViewBracketOpener>

            </Panel>

            <Panel shouldDisplay={displayCreatePanel} headerText="Create Options" closePanel={closeCreatePanel} content={
                (<CreateBracketOpener bracketsToUpdate={bracketsToUpdate}></CreateBracketOpener>)
            }>
            </Panel>

            <FullPagePanel shouldDisplay={displayAccountPanel} closePanel={closeAccountPanel}>
                {displayAccountPanelUI()}
            </FullPagePanel>
            <InstallInstructions></InstallInstructions> 
            <Toast
                toastList={toastMessages}
                position="top-left"
                autoDelete="true"
                autoDeleteTime="5000"
            />
        </>
    );

}


export default LandingPage;
